import React from 'react';
import { Button, notification, Popconfirm } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { UserSwitchOutlined } from '@ant-design/icons';
import { AssignProcTaskToMe } from '../services/workflow';

export type TaskAssignToMeButtonProps = ButtonProps & {
  proctaskidList: Array<{ proctaskid: number }>;
  label: string;
  refetch: () => void;
};

const TaskAssignToMeButton: React.FC<TaskAssignToMeButtonProps> = ({
  size = 'small',
  refetch,
  proctaskidList,
  label,
  ...props
}) => {
  return (
    <Popconfirm
      title="Are you sure?"
      onConfirm={() => {
        AssignProcTaskToMe({
          proctaskidList,
        }).then((resp) => {
          if (resp.code === '200') {
            notification.success({ message: resp.message });
            refetch();
          } else {
            notification.error({ message: resp.message });
          }
        });
      }}
      okText="Yes"
      cancelText="No"
    >
      <Button icon={<UserSwitchOutlined />} {...props}>
        {label}
      </Button>
    </Popconfirm>
  );
};

export default TaskAssignToMeButton;
